import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Row, Col, Button, AutoComplete, Input, DatePicker } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { setFilters } from "../emiDueSlice";
import { fetchEmiDueList, searchCustomers } from "../emiDueThunk";
import dayjs from "dayjs";
import { currentDateEndTime } from "../../../../lib/functions";
import SearchListAutoComplete from "../../../../components/SearchListAutoComplete";

const EmiDueFilters = ({ messageApi }) => {
  const dispatch = useDispatch();
  const { filters } = useSelector((state) => state.emiDue);
  const { searchResults, loadingSearch } = useSelector((state) => state.emiDue);
  const { authInfo } = useSelector((state) => state.auth);

  const handleSearchCustomers = useCallback(
    (text) => {
   
      dispatch(searchCustomers(text));
    },
    [dispatch, authInfo]
  );

  const handleFilterChange = (field, value) => {
    dispatch(setFilters({ [field]: value }));
  };

  const handleReport = () => {
    if (!filters.customerId) {
      messageApi.warning("Select Customer");
      return;
    }

    if (!filters.dateTo) {
      messageApi.warning("Select Date");
      return;
    }

    const payload = {
      customerId: filters.customerId,
      dateTo: filters.dateTo,
    };

    dispatch(fetchEmiDueList(payload)).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        messageApi.success("EMI Due List loaded ✅");
      } else {
        messageApi.error("Failed to fetch EMI Due List ❌");
      }
    });
  };

  return (
    <Card className="mb-4 shadow-md rounded-xl">
      <Row gutter={16} style={{ alignItems: "center" }}>
        <Col xs={24} sm={12} md={12} lg={6}>
          <label>Search Customer</label>
          <SearchListAutoComplete
            id="rc_select_1"
            entityType="customer"
            searchThunk={handleSearchCustomers}
            resultSelector={(state) => state.emiDue.searchResults}
            loading={loadingSearch}
            onSelect={(obj) => {
              if (!obj) {
                // cleared
                handleFilterChange("customerId", null);
                handleFilterChange("customerName", "");
                return;
              }
              handleFilterChange("customerId", obj.acc_id);
              handleFilterChange("customerName", obj.acc_name);
            }}
            placeholder="Customer"
            showAddNew={false}
          />
        </Col>

        <Col xs={24} sm={12} md={12} lg={4}>
          <label>Date</label>
          <DatePicker
            style={{ width: "100%" }}
            data-testid="emi-to-datepicker"
            format="DD/MM/YYYY"
            value={filters.rawTo ? dayjs(filters.rawTo) : null}
            onChange={(date) => {
              if (date) {
              handleFilterChange("rawTo", date?date.format("YYYY-MM-DD") : null); // keep dayjs object as-is
              handleFilterChange("dateTo",date ? currentDateEndTime(date) : null);
              }

            }}
          />
        </Col>

        <Col
          xs={24}
          sm={12}
          md={12}
          lg={4}
          style={{ display: "flex", alignItems: "flex-end", height: 58 }}
        >
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleReport}
            block
            data-testid="btn-get-report"
          >
            Get Report
          </Button>
        </Col>
      </Row>
    </Card>
  );
};

export default EmiDueFilters;
